import React from "react";

export interface TablePaginationFooterProps {
  isLoading?: boolean;
  limit: 10 | 25 | 50 | 100;
  setLimit: (limit: 10 | 25 | 50 | 100) => void;
  page?: number;
  totalRecords?: number;
  setPage?: (page: number) => void;
}

const TablePaginationFooter: React.FC<TablePaginationFooterProps> = ({
  isLoading = true,
  limit,
  setLimit,
  page = 1,
  totalRecords,
  setPage
}) => {
  const totalPages = totalRecords ? Math.ceil(totalRecords / limit) : 0;
  const allowedValues: { [key: string]: 10 | 25 | 50 | 100 } = {
    "10": 10,
    "25": 25,
    "50": 50,
    "100": 100
  };
  return (
    <footer className="w-full p-4 items-end border-t border-gray-300">
      <div className="flex justify-between">
        <div>
          <label>Display Records</label>
          <select
            value={limit}
            onChange={e => {
              setLimit(allowedValues[e.target.value]);
              setPage && setPage(1);
            }}
            className="mx-2 border border-gray-300 py-1 px-3 rounded"
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </div>
        {(isLoading || totalPages > 1) && (
          <div>
            {!isLoading && <label>Page: </label>}
            {totalPages <= 3 ? (
              Array.from({ length: totalPages }, (_, i) => i + 1).map(pageNumber => (
                <button
                  key={pageNumber}
                  onClick={() => setPage && setPage(pageNumber)}
                  className={`mx-1 py-1 px-3 rounded ${
                    pageNumber === page ? "bg-blue-500 text-white" : "border border-gray-300"
                  }`}
                >
                  {pageNumber}
                </button>
              ))
            ) : (
              <>
                <button
                  key={1}
                  onClick={() => setPage && setPage(1)}
                  className={`mx-1 py-1 px-3 rounded ${
                    page === 1 ? "bg-blue-500 text-white" : "border border-gray-300"
                  }`}
                >
                  {1}
                </button>
                {page > 3 && <span className="mx-1">...</span>}
                {Array.from({ length: Math.min(totalPages, 5) }, (_, i) => page - 2 + i)
                  .filter(pageNumber => pageNumber > 1 && pageNumber < totalPages)
                  .map(pageNumber => (
                    <button
                      key={pageNumber}
                      onClick={() => setPage && setPage(pageNumber)}
                      className={`mx-1 py-1 px-3 rounded ${
                        pageNumber === page ? "bg-blue-500 text-white" : "border border-gray-300"
                      }`}
                    >
                      {pageNumber}
                    </button>
                  ))}
                {page < totalPages - 2 && <span className="mx-1">...</span>}
                {totalPages > 1 && (
                  <button
                    key={totalPages}
                    onClick={() => setPage && setPage(totalPages)}
                    className={`mx-1 py-1 px-3 rounded ${
                      page === totalPages ? "bg-blue-500 text-white" : "border border-gray-300"
                    }`}
                  >
                    {totalPages}
                  </button>
                )}
              </>
            )}
          </div>
        )}
      </div>
    </footer>
  );
};
export default TablePaginationFooter;
